import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { iconLeftStyle } from './styles';
function IconLeft({ children, size }) {
    return _jsx("div", Object.assign({ css: iconLeftStyle({ size }) }, { children: children }));
}
export default IconLeft;
